export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/accessories.0bdd84c.svg";